<template>
  <div
    :class="[
      'sj-label',
      `label-${type}`,
      `label-theme-${theme}`,
      `label-size-${size}`,
      { active: value, disabled }
    ]"
    @click="handleClick"
  >
    <slot></slot>
    <span
      v-if="removable"
      @click="$emit('remove')"
      class="sj-label-remove-icon"
    >
      <i class="icon_com commulti_close" />
    </span>
  </div>
</template>

<script>
/**
 * label组件，展示标签。
 */
import sizeMixin from "../../../utils/sizeMixin";

export default {
  name: "SjLabel",
  mixins: [sizeMixin],
  props: {
    type: {
      type: String,
      default: "switch",
      validator: val => ["switch", "display"].includes(val)
    },
    theme: {
      type: String,
      default: "1",
      validator: val => ["1", "2", "3", "4", "5"].includes(val)
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      if (this.type === "switch" && !this.disabled) {
        this.$emit("input", !this.value);
        this.$emit("change", !this.value);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@switch-theme: 1, 2, 3, 4, 5;
@display-theme: 1, 2;
.sj-label {
    border: @base-border-width @base-border-style;
    border-radius: @base-border-radius;
    min-width: 56px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.label-switch {
        &:not(.disabled) {
            cursor: pointer;
        }
        each(@switch-theme, {
            &.label-theme-@{value} {
                @theme-color-name: "color-label-switch-@{value}";
                @theme-color: @@theme-color-name;
                .normal() {
                    color: @theme-color;
                    background-color: transparent;
                    border-color: transparent;
                }
                .anti() {
                    background-color: @theme-color;
                    color: @color-antibg;
                    border-color: transparent;
                }

                .normal();

              &:not(.active) {
                &:not(.disabled) {
                  &:hover {
                    color: @theme-color;
                    border-color: @theme-color;
                    background-color: transparent;
                  }
                }
              }
                &.active {
                    .anti();
                  &:not(.disabled) {
                      &:hover {
                        background-color: fade(@theme-color,50%);
                      }
                  }
                }
            }
        })
    }

    &.label-display {
        border-color: @color-available;
        color: @color-available;
        each(@display-theme, {
            &.label-theme-@{value} {
                @theme-color-name: "color-label-display-@{value}";
                @theme-color: @@theme-color-name;
                background-color: @theme-color;
            }
        })
    }

    each(@sizes, {
        &.label-size-@{value} {
            .size(@value)
        }
    });

  .sj-label-remove-icon{
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
    cursor: pointer;
    i{
      color: @color-normal;
      font-size:12px;
      transform: scale(8/12);
    }
    &:hover{
      background: @color-gray-3;
      i{
        color: @color-available;
      }
    }
  }

}
</style>
